module.exports = __webpack_public_path__ + "assets/images/BULKCASH.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BULKCASH.png
// module id = 1320
// module chunks = 1